import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const PaiementAbandon = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = searchParams.get('SessionId');
    if (!sessionId) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + `/v1/mandat-whois/${sessionId}`);
        const { user_id, offer } = response.data;

        if (user_id && offer) {
          navigate(`/selection-offre?uid=${user_id}&stype=abonnements&sname=${offer}`);
        }
      } catch (error) {
        console.error('Erreur pendant la récupération des données', error);
      }
    };

    fetchData();
  }, [searchParams, navigate]);

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Redirection en cours...</h2>
    </div>
  );
};

export default PaiementAbandon;
